if (!global.$) {
    const $ = require('jquery');
    global.$ = global.jQuery = $;
}
